import { createFileRoute, useParams } from "@tanstack/react-router";
import { OpportunityDetailPage } from "@/components/crm/OpportunityDetailPage";

export const Route = createFileRoute("/user/_layout/crm/opportunities_/$id")({
  component: UserOpportunityDetail,
});

function UserOpportunityDetail() {
  const { id } = useParams({ from: "/user/_layout/crm/opportunities_/$id" });
  return <OpportunityDetailPage opportunityId={id} role="user" />;
}
